import Header from "../components/Header";
import Fondo2 from "../assets/junta.png"
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import IMG1 from "../assets/lentes.jpeg";
import IMG2 from "../assets/papel.jpeg";
import Footer from "../components/Footer";

const About = () => {
    const navigate = useNavigate();
    const areas = [
        {
            title: "Visión",
            text:"Mantener el liderazgo en el desarrollo e implementación de estrategias legales innovadoras que permitan optimizar la carga fiscal y aumentar la competitividad de la empresa.",
            img:IMG1
        },
        {
            title: "Misión",
            text:"Responder a las necesidades específicas del sector empresarial ofreciendo servicios profesionales de la más alta calidad que contribuyan a la realización del objeto social, con la confianza y seguridad del debido cumplimiento de las obligaciones legales, contables y fiscales.",
            img:IMG2
        },
    ];
    return (
        <>
            <Header/>
            <div>
                <div
                    className="w-full h-[60vh] relative bg-cover bg-top bg-no-repeat flex flex-col items-start justify-end p-16 md:pr-[33vw] gap-4"
                    style={{ backgroundImage: `url(${Fondo2})` }}
                >
                    <div className="absolute top-0 left-0 w-full h-full bg-[#533144]/70"></div>
                    <h1 className="text-5xl text-white font-bold z-40">Quiénes somos</h1>
                    <p className="text-white z-40">
                        Somos una empresa mexicana con amplia trayectoria en brindar asesoría empresarial tributaria y financiera,
                        nuestros servicios multidisciplinarios permiten ofrecer a nuestros clientes opciones integrales a sus necesidades.
                    </p>
                </div>
            {areas.map((a)=>(
                <div className="w-full h-auto md:h-[75vh] grid grid-cols-1 md:grid-cols-2 md:px-36">
            <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="w-full h-[55vh] md:h-full bg-contain bg-center bg-no-repeat flex items-center justify-start"
                style={{ backgroundImage: `url(${a.img})` }} 
            />
            <div className="relative w-full h-full flex flex-col justify-center text-left px-4 md:px-0">
                <div className="bg-estra p-12 text-white md:absolute md:-left-0 ">
                <h1 className="font-bold text-4xl">{a.title}</h1>
                    <p className="text-lg text-justify">
                        {a.text}
                    </p>
                    <button className="text-white bg-trasparent border border-white p-2 px-4 rounded-full mx-auto" onClick={()=>navigate("/contact")}>
                        Concertar una cita
                    </button>
                </div>
            </div>
        </div>
        ))}
            </div>
            <Footer/>
        </>
    );
};

export default About;